'use client';

import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

type ItemType = {
  title: string;
  url: string;
  src: string;
};

type GearBagSectionProps = {
  header: string;
  footer: string;
  items: ItemType[];
};

const GearBagSection: React.FC<GearBagSectionProps> = ({ header, footer, items }) => {
  return (
    <section className="px-5 py-16 md:py-36">
      <div className="max-w-[1250px] mx-auto w-full">
        <h3 className="text-center text-[24px] md:text-[29px] font-normal mb-14">
          {header}
        </h3>

        <div className="max-w-[1000px] mx-10 md:mx-auto flex flex-wrap justify-between items-center">
          {items.map((item, index) => (
            <div key={index} className="flex-1 px-4 max-w-[220px]">
              <Link href={item.url} className="block">
                <div className="mb-6 w-full relative">
                  <Image
                    src={item.src}
                    alt={item.title}
                    width={220}
                    height={220}
                    loading="lazy"
                    className="w-full h-auto object-contain rounded-lg"
                  />
                </div>
                <h3 className="text-center text-[20px] font-medium mb-2">{item.title}</h3>
              </Link>
            </div>
          ))}
        </div>

        <h3 className="text-center text-[18px] md:text-[22px] font-normal mt-14">
          {footer}
        </h3>

      </div>
    </section>
  );
};

export default GearBagSection;
